module.exports = __webpack_public_path__ + "static/media/ArrowUpRight.13b72b20.svg";